<template>
  <div style="position: relative;">
    <el-form ref="flowSpecialistAuditList" :model="flowSpecialistAuditList" label-width="120px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <filter-box :item-width="350">
        <el-form-item label="工单状态" prop="formFilter.flowStatus">
          <el-select class="filter-item" v-model="flowSpecialistAuditList.formFilter.flowStatus" :clearable="true"
            placeholder="工单状态">
            <el-option v-for="item in SysFlowWorkOrderStatus.getList()" :key="item.id"
              :label="item.name" :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期" prop="formFilter.createTime">
          <date-range class="filter-item" v-model="flowSpecialistAuditList.formFilter.createTime" :clearable="true" :allowTypes="['day']" align="left"
            range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期"
            format="yyyy-MM-dd" value-format="yyyy-MM-dd HH:mm:ss" />
        </el-form-item>
        <el-form-item label="工单编号" prop="formFilter.workOrderCode">
          <el-input class="filter-item" v-model="flowSpecialistAuditList.formFilter.workOrderCode"
            :clearable="true" placeholder="工单编号"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onReset">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshFlowSpecialistAuditList(true)">查询</el-button>
        <el-button slot="operator" type="primary" :size="defaultFormItemSize"
          @click="onStartTaskClick()">
          新建
        </el-button>
      </filter-box>
    </el-form>
    <el-row>
      <el-col :span="24">
        <el-table ref="specialist" :data="specialistWidget.dataList" :size="defaultFormItemSize"
          @sort-change="specialistWidget.onSortChange"
          header-cell-class-name="table-header-gray">
          <el-table-column label="序号" header-align="center" align="center" type="index" width="55px"
            :index="specialistWidget.getTableIndex"
          />
          <el-table-column label="工单编号" prop="workOrderCode" />
          <el-table-column label="名称" prop="masterData.specialistName">
            <template slot-scope="scope">
              <span>{{(scope.row.masterData.specialistType=='2')?scope.row.masterData.teamName:scope.row.masterData.specialistName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="类型" prop="masterData.specialistTypeDictMap.name">
          </el-table-column>
          <el-table-column label="照片" min-width="100px">
            <template slot-scope="scope">
              <el-image v-for="item in parseUploadData(scope.row.masterData.specialistAvatar, {id: scope.row.masterData.id, fieldName: 'specialistAvatar', asImage: true})"
                :preview-src-list="getPictureList(scope.row.masterData.specialistAvatar, {id: scope.row.masterData.id, fieldName: 'specialistAvatar', asImage: true})"
                class="table-cell-image" :key="item.url" :src="item.url" fit="fill">
                <div slot="error" class="table-cell-image">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="联系电话" prop="masterData.mobilePhone">
          </el-table-column>
          <el-table-column label="申请时间" prop="masterData.createTime">
            <template slot-scope="scope">
              <span>{{formatDateByStatsType(scope.row.masterData.createTime, 'day')}}</span>
            </template>
          </el-table-column>
          <el-table-column label="当前任务" prop="runtimeTaskInfo.taskName" />
          <el-table-column label="流程创建时间" prop="createTime" />
          <el-table-column label="流程状态" prop="latestApprovalStatusDictMap.name" width="100px" />
          <el-table-column label="工单状态" prop="flowStatus"  width="100px">
            <template slot-scope="scope">
              <span>{{SysFlowWorkOrderStatus.getValue(scope.row.flowStatus)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" :size="defaultFormItemSize"
                v-if="(scope.row.initTaskInfo || {}).taskKey !== (scope.row.runtimeTaskInfo || {}).taskKey"
                @click.stop="onViewTaskClick(scope.row)">
                详情
              </el-button>
              <el-button type="text" :size="defaultFormItemSize"
                v-if="(scope.row.initTaskInfo || {}).taskKey === (scope.row.runtimeTaskInfo || {}).taskKey"
                @click.stop="onHandlerTaskClick(scope.row)">
                办理
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn"
                @click.stop="onRemindClick(scope.row)">
                催办
              </el-button>
              <el-button type="text" :size="defaultFormItemSize" class="table-btn error"
                @click.stop="onCancelTaskClick(scope.row)">
                取消
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" justify="end" style="margin-top: 10px;">
          <el-pagination
            :total="specialistWidget.totalCount"
            :current-page="specialistWidget.currentPage"
            :page-size="specialistWidget.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            layout="total, prev, pager, next, sizes"
            @current-change="specialistWidget.onCurrentPageChange"
            @size-change="specialistWidget.onPageSizeChange">
          </el-pagination>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import '@/staticDict/flowStaticDict.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import { SpecialistController, DictionaryController } from '@/api';
/* eslint-disable-next-line */
import { FlowOperationController } from '@/api/flowController.js';

const processDefinitionKey = 'flowSpecialistAudit';
const processDefinitionName = '专家认证审核';

export default {
  name: 'flowSpecialistAuditList',
  props: {
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin],
  data () {
    return {
      flowSpecialistAuditList: {
        formFilter: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: []
        },
        formFilterCopy: {
          flowStatus: undefined,
          workOrderCode: undefined,
          createTime: []
        },
        isInit: false
      },
      specialistWidget: new TableWidget(this.loadSpecialistData, this.loadSpecialistVerify, true)
    }
  },
  methods: {
    onReset () {
      this.$refs.flowSpecialistAuditList.resetFields();
      this.refreshFlowSpecialistAuditList(true);
    },
    loadSpecialistData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        flowWorkOrderDtoFilter: {
          flowStatus: this.flowSpecialistAuditList.formFilterCopy.flowStatus,
          workOrderCode: this.flowSpecialistAuditList.formFilterCopy.workOrderCode,
          createTimeStart: Array.isArray(this.flowSpecialistAuditList.formFilterCopy.createTime) ? this.flowSpecialistAuditList.formFilterCopy.createTime[0] : undefined,
          createTimeEnd: Array.isArray(this.flowSpecialistAuditList.formFilterCopy.createTime) ? this.flowSpecialistAuditList.formFilterCopy.createTime[1] : undefined
        },
        orderParam: [
          {
            fieldName: 'createTime',
            asc: false
          }
        ]
      }
      return new Promise((resolve, reject) => {
        SpecialistController.listWorkOrderFlowSpecialistAudit(this, params).then(res => {
          let dataList = res.data.dataList.map(item => {
            item.initTaskInfo = JSON.parse(item.initTaskInfo);
            item.runtimeTaskInfo = Array.isArray(item.runtimeTaskInfoList) ? item.runtimeTaskInfoList[0] : undefined;
            item.masterData = item.masterData || {};
            return item;
          });
          resolve({
            dataList: dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        })
      });
    },
    loadSpecialistVerify () {
      this.flowSpecialistAuditList.formFilterCopy.flowStatus = this.flowSpecialistAuditList.formFilter.flowStatus;
      this.flowSpecialistAuditList.formFilterCopy.workOrderCode = this.flowSpecialistAuditList.formFilter.workOrderCode;
      this.flowSpecialistAuditList.formFilterCopy.createTime = this.flowSpecialistAuditList.formFilter.createTime;
      return true;
    },
    // 启动流程
    onStartTaskClick () {
      let params = {
        processDefinitionKey: processDefinitionKey
      }

      FlowOperationController.viewInitialTaskInfo(this, params).then(res => {
        if (res.data && res.data.taskType === this.SysFlowTaskType.USER_TASK && res.data.assignedMe) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              processDefinitionKey: processDefinitionKey,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: '启动流程',
              isDraft: true,
              flowEntryName: processDefinitionName,
              variableList: res.data.variableList,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              })
            }
          });
        } else {
          FlowOperationController.startOnly(this, {
            processDefinitionKey: processDefinitionKey
          }).then(res => {
            this.$message.success('启动成功！');
          }).catch(e => {});
        }
      }).catch(e => {});
    },
    // 办理流程
    onHandlerTaskClick (row) {
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      let params = {
        processInstanceId: row.processInstanceId,
        processDefinitionId: row.processDefinitionId,
        taskId: taskId
      }

      FlowOperationController.viewRuntimeTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: true,
              isDraft: row.flowStatus === this.SysFlowWorkOrderStatus.DRAFT,
              taskId: taskId,
              processDefinitionKey: processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              formId: res.data.formId,
              routerName: res.data.routerName,
              readOnly: res.data.readOnly,
              taskName: (row.runtimeInitialTask || {}).taskName,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator,
              operationList: (res.data.operationList || []).filter(item => {
                return item.type !== this.SysFlowTaskOperationType.CO_SIGN && item.type !== this.SysFlowTaskOperationType.REVOKE;
              }),
              variableList: res.data.variableList
            }
          });
        }
      }).catch(e => {});
    },
    // 查看流程
    onViewTaskClick (row) {
      let params = {
        processInstanceId: row.processInstanceId
      }
      let taskId = (Array.isArray(row.runtimeTaskInfoList) && row.runtimeTaskInfoList.length > 0) ? row.runtimeTaskInfoList[0].taskId : undefined;
      FlowOperationController.viewInitialHistoricTaskInfo(this, params).then(res => {
        if (res.data) {
          this.$router.push({
            name: res.data.routerName || 'handlerFlowTask',
            query: {
              isRuntime: false,
              taskId: taskId,
              processDefinitionKey: row.processDefinitionKey,
              processInstanceId: row.processInstanceId,
              processDefinitionId: row.processDefinitionId,
              routerName: res.data.routerName,
              readOnly: true,
              flowEntryName: row.processDefinitionName,
              processInstanceInitiator: row.processInstanceInitiator
            }
          });
        }
      }).catch(e => {});
    },
    // 催办
    onRemindClick (row) {
      FlowOperationController.remindRuntimeTask(this, {
        workOrderId: row.workOrderId
      }).then(res => {
        this.$message.success('催办成功');
      }).catch(e => {});
    },
    // 撤销流程
    onCancelTaskClick (row) {
      this.$confirm('是否取消此工单？').then(res => {
        let params = {
          workOrderId: row.workOrderId,
          cancelReason: '主动取消'
        }

        FlowOperationController.cancelWorkOrder(this, params).then(res => {
          this.$message.success('取消成功！');
          this.refreshFlowSpecialistAuditList();
        }).catch(e => {});
      }).catch(e => {});
    },
    // 刷新工单
    refreshFlowSpecialistAuditList (reloadData = false) {
      if (reloadData) {
        this.specialistWidget.refreshTable(true, 1);
      } else {
        this.specialistWidget.refreshTable();
      }
      if (!this.flowSpecialistAuditList.isInit) {
        // 初始化下拉数据
      }
      this.flowSpecialistAuditList.isInit = true;
    },
    onResume () {
      this.refreshFlowSpecialistAuditList();
    },
    formInit () {
      this.refreshFlowSpecialistAuditList();
    }
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
    '$route' () {
      this.formInit();
    }
  }
}
</script>

<style>
</style>
